import type { Control, FieldValues, Path } from "react-hook-form";

import { useMemo } from "react";
import { Controller } from "react-hook-form";

import { MultiSelect2 } from "@/components/multi-select-2/MultiSelect2";
import { useResolveBrands } from "@/features/users/hooks/useResolveBrands";

type SelectAccountProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  projectIds: null | number[];
};

export function AssignedBrands<T extends FieldValues>({
  control,
  name,
  projectIds,
}: SelectAccountProps<T>) {
  const { data } = useResolveBrands(projectIds ?? []);

  const accounts = useMemo(
    () =>
      (data || [])
        .filter((d) => d.brandId != null)
        .map((d) => ({
          avatar: undefined,
          description: d.projectName,
          href: `/brands/${d.brandId}/overview`,
          id: d.brandId,
          textValue: d.brandName,
        })),
    [data],
  );

  return (
    <div className="space-y-2 mt-4">
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <MultiSelect2
            isDisabled={!projectIds?.length}
            label="Assigned brands"
            onRemove={(key) => {
              field.onChange(
                field.value.filter((id: number) => id !== Number(key)),
              );
            }}
            onSelect={(key) => {
              const numKey = Number(key);

              if (!field.value.includes(numKey)) {
                field.onChange([...field.value, numKey]);
              }
            }}
            options={accounts}
            placeholder="Search to add brands..."
            selectedIds={field.value}
          />
        )}
      />
    </div>
  );
}
